import _ from "underscore";
import Backbone from "backbone";
import { Config } from "../application/Config";

export const Display = Backbone.Model.extend({
    urlRoot: "/devices",

    defaults: {
        config: {
            "header": {
                "height": null,
                "textColor": "#FFFFFF",
                "title": null,
                "backgroundType": "color",
                "backgroundColor": "#0681B3",
                "backgroundImage": null,
                "backgroundPosition": "center",
                "backgroundSize": "cover",
                "logoImage": "img/xola-logo.png",
                "logoSize": "2em"
            },
            "events": {
                "listings": {
                    "all": true,
                    "selected": []
                },
                "capacity": "available",
                "availability": "available",
                "showTomorrowsEvents": false,
                "nameOverrides": {},
                "rowBackgroundColorOdd": "#FFFFFF",
                "rowBackgroundColorEven": "#F8F8F8",
                "rowTextColor": "#383C48",
                "availabilityColorAvailable": "#8CC34A",
                "availabilityColorHalfFull": "#F3B53A",
                "availabilityColorAlmostFull": "#DA5E47",
                "availabilityColorFull": null,
                "availabilityBlink": true,
                "showDuration": true,
                "showGuides": false,
                "showPrice": true,
                "showDemographics": false,
                "hideTimeout": 0
            }
        },
    },

    sync(method, model, options) {
        var beforeSend = options.beforeSend;
        options.beforeSend = (jqXHR, settings) => {
            settings.url = Config.baseUrl.configuration + settings.url;
            if (Config.baseUrl.configuration != Config.baseUrl.ui) {
                settings.crossDomain = true;
            }

            if (Config.user && Config.user.has('apiKey')) {
                jqXHR.setRequestHeader("X-USER-ID", Config.user.id);
                jqXHR.setRequestHeader("X-API-KEY", Config.user.get('apiKey'));
                jqXHR.setRequestHeader("X-SELLER-ID", Config.seller.id);
            }

            if (beforeSend) return beforeSend.call(this, jqXHR, settings);
        };

        return Backbone.Model.prototype.sync.call(this, method, model, options);
    },

    parse(response) {
        // Perform a deep defaults operation
        if (response && response.config) {
            _.defaults(response.config.header, this.defaults.config.header);
            _.defaults(response.config.events, this.defaults.config.events);
            _.defaults(response.config.events.listings, this.defaults.config.events.listings);
        }

        return response;
    }
});


// WEBPACK FOOTER //
// ./src/js/model/Display.js